import * as tslib_1 from "tslib";
import store from '../store/store';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import selectQuickSuggestionOption from '../actions/selectQuickSuggestionOption';
import { getFallbackValueIfNull } from 'owa-options-core';
var QuickSuggestionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(QuickSuggestionsFull, _super);
    function QuickSuggestionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuickSuggestionsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isEnabled = getFallbackValueIfNull(optionStore.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
        var useLocation = getFallbackValueIfNull(optionStore.browserLocationEnabled, userOptions.browserLocationEnabled);
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_mail_quickSuggestionsDescription),
            React.createElement(OptionsCheckbox, { checked: isEnabled, label: strings.options_mail_quickSuggestionsEnable, onChange: this.toggleEnable }),
            React.createElement(OptionsCheckbox, { disabled: !isEnabled, checked: useLocation, label: strings.options_mail_quickSuggestionsLocation, onChange: this.toggleLocation })));
    };
    QuickSuggestionsFull.prototype.toggleEnable = function (ev, checked) {
        selectQuickSuggestionOption('smartSuggestionsEnabled', checked);
    };
    QuickSuggestionsFull.prototype.toggleLocation = function (ev, checked) {
        selectQuickSuggestionOption('browserLocationEnabled', checked);
    };
    QuickSuggestionsFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () {
                return getOptionsForFeature(OwsOptionsFeatureType.SmartSuggestions);
            },
        })
    ], QuickSuggestionsFull);
    return QuickSuggestionsFull;
}(React.Component));
export default QuickSuggestionsFull;
//# sourceMappingURL=QuickSuggestionsFull.js.map